import { TThunkAction } from '../../types/redux';
import { notify } from '../../actions/notifications';
import { ENotificationStyle } from '../../types/notifications';
import { fetchDeleteFolders, IDeleteFoldersRequest } from '../../repositories/favorites/v1/delete-folders';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { removeFolder, selectFolder } from '../../actions/folders/actions';

export const deleteFolder = (id: number): TThunkAction<Promise<void>> => async (
  dispatch,
  getState,
  { httpApi, logger },
) => {
  const parameters: IDeleteFoldersRequest = {
    ids: [id],
  };

  const showError = () => dispatch(notify('Не удалось удалить подборку', ENotificationStyle.Error));

  try {
    dispatch(selectFolder({ folder: null }));

    const { statusCode, response } = await fetchDeleteFolders({ httpApi, parameters });

    if (statusCode === 200) {
      dispatch(fetchFavoriteEntities({ offset: 0 }));
      dispatch(removeFolder({ id }));
    }

    if (statusCode === 400) {
      showError();
      logger.warning(response.message);
    }
  } catch (e) {
    showError();
    logger.error(e, {
      description: 'Fail to remove favorites folder',
    });
  }
};
